import React, { useRef } from 'react';
import moment from 'moment';
import {
  GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  SAVE_QUOTE_TWO_WHEELER,
  SAVE_QUOTE,
} from '../queries';
//import { updateBuyHealthPolicy,resetProposerDetails } from '../_graphqlscpa/state';
//import  {updateBuyHealthPolicy}  from '../_graphqlscpa/state';
//import { resetProposerDetails } from '../_graphqlscpa/state';
import { updateBuyHealthPolicy ,resetProposerDetails} from 'quanta-flows/modules/proposal/health/state';
//import ProposerDetails from '../../../../common/proposer-details';
//import { ProposerDetails } from 'quanta-flows/modules/proposal/health';
import { ProposerDetails } from 'quanta-flows/modules/common/proposer';


//import { ProposerDetails } from 'quanta-flows/modules/proposal/motor';
import { useQuery } from '@apollo/client';

export default function ProposerDetailsTwoWheeler({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  lobCode,
  lobName,
  productCode,
  productName,
  productType,
  ...props
}) {
  const initLoadRef = useRef([]);
  const {
    loading: loadingBuyMotorPolicy,
    error: errorBuyMotorPolicy,
    data: dataBuyMotorPolicy,
    previousData: previousDataBuyMotorPolicy,
  } = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: new Set(initLoadRef?.current)?.size >= 1,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });
  const saveQuoteVariables = ({ lob_code, product_code, values }) => {
   
    let riskInput = [];
    values?.coverData?.rawRiskData?.forEach((r) => {
      let covers = [];
      r.covers
        .filter(
          (c) => values?.coverData[`addOnCovers`][c?.name]?.selected,
        )
        .forEach((c) => {
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${
                    values?.coverData[`addOnCovers`][`${c?.name}`][
                      `attributes`
                    ][`${attribute?.name}`]
                  }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    return {
      input: {
        quotationType: values?.quotationType,
        quoteCreationDate: moment().format('YYYY-MM-DD').toString(),
        customer: values?.proposerDetails,
        // custCkyc: '123444',
        // panNo: 'BSAPG7676S',
        lob: 28,
        product: productCode,
        location: {
          pinCode: values?.quoteData?.location?.pincode,
          state: values?.quoteData?.location?.state,
          district: values?.quoteData?.location?.district,
          city: values?.quoteData?.location?.city,
          zone: values?.quoteData?.location?.zone,
        },
        intermediary: {
          intermediaryCode: values?.intermediaryDetails?.code,
          locationCode: values?.intermediaryDetails?.location,
          fieldUserCode: values?.intermediaryDetails?.fieldUserCode,
        },
        members: values?.quoteData?.members,
        // values?.quoteData?.VehicleType
          
        //   .map((member,idx) => {
        //     return {
        //       relationship: values?.quoteData?.VehicleType[idx],
        //     gender: 'MALE',
        //   dob: '21/12/1998',
        //   age: '23',
        //     };
        //   }),
        cover: {
          type: values?.quoteData?.cover?.type,
          sumInsured: parseInt(values?.quoteData?.cover?.sum_insured),
          tenure: values?.quoteData?.cover?.tenure,
        },
        plans: values?.planData?.plans?.filter((plan)=>plan?.isSelected)?.map((plan) => {
          return {
            name: plan?.name,
            code: plan?.code,
            covers: plan?.covers?.map((cover) => {
              return { name: cover?.name, index: cover?.index };
            }),
            packs: plan?.packs?.map((pack) => {
              return {
                name: pack?.name,
                index: pack?.index,
                addOnCovers: pack?.addOnCovers?.map((addOn) => {
                  return {
                    name: addOn?.name,
                    index: addOn?.index,
                    selected: addOn?.selected,
                  };
                }),
              };
            }),
            premium: {
              basePremium: plan?.premium?.basePremium,
              loadingDiscount: plan?.premium?.loadingDiscount,
              netPremium: plan?.premium?.netPremium,
              gst: plan?.premium?.gst,
              stampDuty: plan?.premium?.stampDuty,
              totalPremium: plan?.premium?.totalPremium,
              loading: plan?.premium?.loading?.map((loading) => {
                return {
                  name: loading?.name,
                  amount: loading?.amount,
                };
              }),
              discount: plan?.premium?.discount?.map((discount) => {
                return {
                  name: discount?.name,
                  amount: discount?.amount,
                };
              }),
              breakup: plan?.premium?.breakup?.map((brkup) => {
                return {
                  relationship: brkup?.relationship,
                  gender: brkup?.gender,
                  age: brkup?.age,
                  premium: brkup?.premium,
                };
              }),
            },
          };
        }),
        existingPolicyNumber: values?.quoteData?.existingPolicyNumber,
        isExistingEmployee: values?.proposerDetails?.employeeNumber
          ? true
          : false,
      },
    };
  };

  return (
    <>
      {!loadingBuyMotorPolicy && !errorBuyMotorPolicy && (
        <ProposerDetails
          {...{
            REACTIVE_VAR_QUERY: GET_BUY_HEALTH_POLICY_VAR_DETAILS,
            SAVE_QUOTE_QUERY: SAVE_QUOTE,
            goToStep,
            proceedToNextStep,
            resetProposerDetails,
            saveQuoteVariables,
            setCustomLoadingMessage,
            setLoadingStep,
            setParentAlerts,
            setProceedToNextStep,
            updateReactiveVar: updateBuyHealthPolicy,
            preCustomerType: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.organisationType
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.organisationType,
            preGender: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.gender
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.gender,
            prePermPincode: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.pincode
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.pincode,
            prePermState: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.state
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.state,
            prePermDistrict: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.district
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.district,
            prePermCityTownVillage: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.city
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.city,
            ...props,
          }}
        />
      )}
    </>
  );
}
